import { render } from "./Loan_Application_Details.vue?vue&type=template&id=5cbc587a&scoped=true"
import script from "./Loan_Application_Details.vue?vue&type=script&lang=js"
export * from "./Loan_Application_Details.vue?vue&type=script&lang=js"

import "./Loan_Application_Details.vue?vue&type=style&index=0&id=5cbc587a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbc587a"]])

export default __exports__